import { render, staticRenderFns } from "./planosMensais.vue?vue&type=template&id=0eaf4985"
import script from "./planosMensais.vue?vue&type=script&lang=js"
export * from "./planosMensais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports